import { useMemo } from "react";
import axios from "axios";
import { getSessionToken } from "./sessionToken";
import { attachDeviceHeaders } from "./deviceTracking";

function useApi(isScheduled) {
  let baseUrl = process.env.REACT_APP_API_URL;

  if (isScheduled) {
    baseUrl = baseUrl.replace("/embedded", "/scheduler");
  }

  const httpRequest = useMemo(() => {
    const instance = axios.create({
      baseURL: baseUrl,
      // Kept so the `np-sending` cookie still works for ordinary top-level use
      // and across a page reload. Inside an iframe the browser drops it, which
      // is what the Bearer header below is for.
      withCredentials: true,
      headers: {
        "Content-Type": "application/json",
      },
    });

    // Read the token per request rather than when the instance is built: sign-in
    // stores it after the first API calls have already been created.
    instance.interceptors.request.use((config) => {
      const token = getSessionToken();
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
      return config;
    });

    attachDeviceHeaders(instance, "sending-app");

    return instance;
  }, [baseUrl]);

  let api = httpRequest;

  return api;
}

export default useApi;
